import React from "react";

import { Checkbox } from "@graffer-inc/console-design-kit";
import { InputElementUnion } from "@graffer-inc/form-schema";
import { TenantProcessResultSetting } from "@graffer-inc/cloud-gov-core";

import { ProcedureEntity } from "../../../../application/domain/procedures/procedure-entity";

type Props = {
  procedure: ProcedureEntity;
  selectable: SelectableAppMeta;
  includeTenantProcessResult: boolean;
  onCheckIncludeTenantProcessResult: (checked: boolean) => void;
  tenantProcessResultSetting: TenantProcessResultSetting | undefined;
};

export type SelectableAppMeta = {
  selectedMetaIds: Array<string>;
  toggleById: (id: string) => void;
  toggleAll: (checked: boolean) => void;
};

const tenantProcessResultInfo = (inputElements?: InputElementUnion[]) => {
  if (!inputElements) {
    return `設定されていないため、管理情報は出力できません`;
  }
  const etcStr = inputElements.length > 2 ? "など" : "";
  return `管理情報として設定している
${inputElements
  .slice(0, 2)
  .map((e) => `「${e.label.text}」`)
  .join("、")
  .concat(etcStr)}
をあわせて出力できます。
管理情報は申請情報の後列に出力されます。`;
};

export const CsvOutputValueOption: React.FC<Props> = ({
  procedure,
  selectable,
  includeTenantProcessResult,
  onCheckIncludeTenantProcessResult,
  tenantProcessResultSetting,
}) => {
  const metaData = procedure.allCSVMetaField();
  const isAllSelected =
    selectable.selectedMetaIds.length === metaData.length &&
    (!tenantProcessResultSetting || includeTenantProcessResult);

  return (
    <>
      <div className="mb-2">
        <h5 className="title is-5">出力する項目</h5>
      </div>
      <div
        className="mb-4 pr-1 pb-1"
        style={{
          borderBottom: "1px solid rgba(128,128,128)",
        }}
      >
        <Checkbox
          label=""
          options={[
            {
              value: "allSelected",
              name: "全て選択する",
            },
          ]}
          onChange={(e) => {
            e.stopPropagation();
            selectable.toggleAll(e.target.checked);
            onCheckIncludeTenantProcessResult(
              !!tenantProcessResultSetting && e.target.checked,
            );
          }}
          description={""}
          values={isAllSelected ? ["allSelected"] : []}
        />
      </div>
      <div>
        <Checkbox
          label=""
          options={[
            ...metaData.map((meta) => {
              return {
                value: meta.id,
                name: meta.name,
              };
            }),
            {
              value: "includeTenantProcessResult",
              name: "管理情報",
              description: tenantProcessResultInfo(
                tenantProcessResultSetting?.inputElements,
              ),
              disabled: !tenantProcessResultSetting,
            },
            {
              value: "includeAttachedFile",
              name: "添付ファイル",
              description:
                "添付ファイル名の列に「refKey_file_」から始まるIDが表示されます。ファイルが添付されていない場合には空白になります。",
              disabled: true,
            },
          ]}
          onChange={(e) => {
            e.stopPropagation();
            if (e.target.value === "includeTenantProcessResult") {
              onCheckIncludeTenantProcessResult(e.target.checked);
              return;
            }
            selectable.toggleById(e.target.value);
          }}
          description={""}
          // 添付ファイル(includeAttachedFile)は必ずチェックが有効かつ操作できないようにしている
          // ref. https://graffer.atlassian.net/browse/PRODUCTS-8070
          values={
            includeTenantProcessResult
              ? [
                  ...selectable.selectedMetaIds,
                  "includeTenantProcessResult",
                  "includeAttachedFile",
                ]
              : [...selectable.selectedMetaIds, "includeAttachedFile"]
          }
        />
      </div>
    </>
  );
};
